/* yn-shop.js — package D (shop).
   Quick add (Yuno.quickAdd.open), the cart sheet and cart page (Yuno.cart.open / close, live line changes, undo, ship bar),
   the collection controller (size chips, filters, sort, show more, sold-out group, keeping her place), and a few motion helpers.
   Plain JS, no libraries. Loaded with defer by sections/yn-cart-sheet.liquid, so it is on every page.
   Written against the contract in BUILD-SPEC.md sections 7, 8 and 11; every call into window.Yuno has a plain fallback. */
(function () {
  'use strict';
  if (window.__ynShop) return;
  window.__ynShop = true;

  var d = document, de = d.documentElement;
  var Y = window.Yuno = window.Yuno || {};
  var OUT = 'cubic-bezier(.2,.8,.2,1)', IN = 'cubic-bezier(.4,0,1,1)', SPRING = 'cubic-bezier(.3,1.4,.5,1)';
  var SIZES_FALLBACK = ['18-24 months', '2-3 years', '3-4 years', '4-5 years', '5-6 years', '6-7 years'];

  /* ================= helpers ================= */
  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  /* Yuno.T('Only [n] left', { n: 3 }): the text in the visitor's language (set up in snippets/yn-head.liquid). English is written in sentence case.
     Resolved at the moment of the call, with a plain fallback so nothing breaks if the helper is missing.
     TH is the same for a string that goes into innerHTML: the text is escaped, the values given are HTML and are put in as they are. */
  function T(s, p) {
    var f = window.Yuno && window.Yuno.T;
    if (typeof f === 'function') return f(s, p);
    s = String(s == null ? '' : s);
    if (p) for (var k in p) { if (Object.prototype.hasOwnProperty.call(p, k)) s = s.split('[' + k + ']').join(p[k]); }
    return s;
  }
  function TH(s, p) {
    var out = esc(T(s));
    if (p) for (var k in p) { if (Object.prototype.hasOwnProperty.call(p, k)) out = out.split('[' + k + ']').join(p[k]); }
    return out;
  }
  function cfg() { return Y.config || {}; }
  function routes() { return cfg().routes || {}; }
  function lowStock() { var n = Number(cfg().lowStock); return n > 0 ? n : 5; }
  function sizes() { var s = cfg().sizes; return s && s.length ? s : SIZES_FALLBACK; }
  function reduced() {
    return de.classList.contains('yn-reduced') || !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function upgrades() { return !reduced() && cfg().upgrades !== false; }
  function isEG() { var m = cfg().market; return m ? m === 'EG' : true; }
  function money(c) {
    if (typeof Y.money === 'function') return Y.money(c);
    return 'LE ' + (Number(c) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' EGP';
  }
  function normSize(v) {
    if (typeof Y.normSize === 'function') return Y.normSize(v);
    var s = String(v == null ? '' : v).toLowerCase().replace(/[–—]/g, '-').replace(/ *- */g, '-').replace(/ +/g, ' ').trim();
    if (s === '12-24 months') s = '18-24 months';
    return SIZES_FALLBACK.indexOf(s) > -1 ? s : '';
  }
  function wa(text) {
    if (typeof Y.wa === 'function') return Y.wa(text);
    return 'https://wa.me/' + (cfg().whatsapp || '201044141173') + '?text=' + encodeURIComponent(text);
  }
  function emit(n, det) { try { d.dispatchEvent(new CustomEvent(n, { detail: det })); } catch (e) {} }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function anim(el, kf, o) { if (!el || !el.animate) return null; try { return el.animate(kf, o); } catch (e) { return null; } }
  function errMsg(e, fallback) {
    var m = e && (e.message || e.description);
    if (!m && typeof e === 'string') m = e;
    return m && m !== 'Failed to fetch' ? m : T(fallback || 'Couldn’t add that. Check your connection and try again.');
  }
  function toast(msg, o) { if (typeof Y.toast === 'function') Y.toast(msg, o || {}); }
  function jpost(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || T('Couldn’t update the cart.'));
          return j;
        });
      });
  }
  function cartSync() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      if (Y.cart) Y.cart.state = c;
      emit('yuno:cart', { cart: c });
      return c;
    });
  }
  function cartAdd(items, o) {
    if (Y.cart && typeof Y.cart.add === 'function') return Y.cart.add(items, o || {});
    return jpost((routes().cartAdd || '/cart/add') + '.js', { items: items }).then(function (r) { return cartSync().then(function (c) { emit('yuno:cart:added', { items: items, source: (o && o.source) || 'shop' }); return c; }); });
  }
  function cartChange(key, qty) {
    if (Y.cart && typeof Y.cart.change === 'function') return Y.cart.change(key, qty);
    return jpost((routes().cartChange || '/cart/change') + '.js', { id: key, quantity: qty }).then(function () { return cartSync(); });
  }
  function cartNote(text) {
    if (Y.cart && typeof Y.cart.note === 'function') return Y.cart.note(text);
    return jpost((routes().cartUpdate || '/cart/update') + '.js', { note: text });
  }
  function sizeGet() {
    try {
      if (Y.size && typeof Y.size.get === 'function') return Y.size.get() || null;
      return localStorage.getItem('yuno-age') || null;
    } catch (e) { return null; }
  }
  function sizeSet(v) {
    if (Y.size && typeof Y.size.set === 'function') { Y.size.set(v || null); return; }
    try { if (v) localStorage.setItem('yuno-age', v); else localStorage.removeItem('yuno-age'); } catch (e) {}
    emit('yuno:size', { size: v || null });
  }
  function sheetOpen(id, opts) {
    if (Y.sheet && typeof Y.sheet.open === 'function') { Y.sheet.open(id, opts || {}); return; }
    var s = $('#' + id); if (s) s.hidden = false;
  }
  /* the shared add button (dots, tick, "added!", the photo flying to the cart mark, the count held until it lands) lives in yn-core.js */
  function runAdd(btn, promise, photo, extra) {
    if (btn && typeof Y.addButton === 'function') return Y.addButton(btn, promise, Object.assign({ photo: photo, doneLabel: T('Added!'), hold: 600 }, extra || {}));
    return Promise.resolve(promise);
  }
  function sheetClose(id) {
    if (Y.sheet && typeof Y.sheet.close === 'function') { Y.sheet.close(id); return; }
    var s = $('#' + id); if (s) s.hidden = true;
  }

  /* ================= small motion helpers (answer / explain / charm) ================= */
  function pop(el, big) {
    if (!el || reduced()) return;
    anim(el, [{ transform: 'scale(1)' }, { transform: 'scale(' + (big || 1.3) + ')' }, { transform: 'scale(1)' }], { duration: 360, easing: SPRING });
  }
  function popPill(el) {
    if (!el || reduced()) return;
    anim(el, [{ transform: 'scale(.94)' }, { transform: 'scale(1.04) rotate(-1deg)' }, { transform: 'scale(1) rotate(-1deg)' }], { duration: 180, easing: SPRING });
  }
  function shake(el, px) {
    if (!el || reduced()) return;
    var n = px || 3;
    anim(el, [{ transform: 'translateX(0)' }, { transform: 'translateX(' + (-n) + 'px)' }, { transform: 'translateX(' + n + 'px)' }, { transform: 'translateX(' + (-n) + 'px)' }, { transform: 'translateX(' + n + 'px)' }, { transform: 'translateX(0)' }], { duration: 320, easing: 'ease-in-out' });
  }
  function countTo(el, from, to, fmt, dur) {
    if (!el) return;
    fmt = fmt || String;
    if (reduced() || from === to || typeof from !== 'number' || isNaN(from)) return;   /* the element already holds its final text */
    var t0 = performance.now(), D = dur || 400, finalText = el.textContent;   /* the last frame is the text the server drew */
    (function tick(t) {
      var u = Math.min(1, (t - t0) / D), e = 1 - Math.pow(1 - u, 3);
      el.textContent = u < 1 ? fmt(Math.round(from + (to - from) * e)) : (finalText || fmt(to));
      if (u < 1) requestAnimationFrame(tick);
    })(t0);
  }
  /* the one celebration: a handful of hand-drawn SVG shapes, 14 pieces, inside 800ms */
  function burst(x, y) {
    if (reduced()) return;
    var cols = ['#fece00', '#0040ea', '#f49ac1', '#1f9a5b', '#ff6a1a'];
    var shapes = [
      function (c) { return '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="M12 2.5l2.8 6.2 6.7.7-5 4.6 1.4 6.6L12 17.2 6.1 20.6l1.4-6.6-5-4.6 6.7-.7z" fill="' + c + '"/></svg>'; },
      function (c) { return '<svg viewBox="0 0 24 12" width="18" height="9" aria-hidden="true"><path d="M1 6c3-5 5 5 8 0s5 5 8 0 4 3 6 0" stroke="' + c + '" stroke-width="2.6" stroke-linecap="round" fill="none"/></svg>'; },
      function (c) { return '<svg viewBox="0 0 12 12" width="9" height="9" aria-hidden="true"><circle cx="6" cy="6" r="5" fill="' + c + '"/></svg>'; }
    ];
    for (var i = 0; i < 14; i++) {
      var s = d.createElement('span'), ang = (i / 14) * 6.283 + Math.random() * 0.4, r = 46 + Math.random() * 44;
      s.innerHTML = shapes[i % 3](cols[i % 5]);
      s.style.cssText = 'position:fixed;z-index:2147483000;margin:-8px 0 0 -8px;pointer-events:none;line-height:0;left:' + x + 'px;top:' + y + 'px';
      d.body.appendChild(s);
      (function (el, a, rr, k) {
        var an = anim(el, [{ transform: 'translate(0,0) rotate(0) scale(1)', opacity: 1 }, { transform: 'translate(' + Math.cos(a) * rr + 'px,' + Math.sin(a) * rr + 'px) rotate(' + (200 + k * 20) + 'deg) scale(.6)', opacity: 0 }], { duration: 760, easing: OUT });
        if (an) an.finished.then(function () { el.remove(); }, function () { el.remove(); }); else el.remove();
      })(s, ang, r, i);
    }
  }
  function hop(el) {
    if (!el || reduced()) return;
    anim(el, [
      { transform: 'translateY(0) scale(1,1)' },
      { transform: 'translateY(4px) scale(1.08,.9)', offset: 0.15 },
      { transform: 'translateY(-16px) scale(.94,1.08)', offset: 0.5 },
      { transform: 'translateY(0) scale(1.06,.94)', offset: 0.8 },
      { transform: 'translateY(0) scale(1,1)' }
    ], { duration: 620, easing: OUT });
  }

  /* ================= CART: live render of the sheet and the page ================= */
  var cartSeq = 0, renderingSig = null, renderPromise = null, lastCart = null;
  var busy = {}, qq = {}, hl = null, celebratePending = false, noteTimer = null, lastNote = null;

  function cartRoots() { return $$('[data-yn-cart-root]'); }
  function sigOf(c) {
    var s = '';
    (c.items || []).forEach(function (i) { s += i.key + ':' + i.quantity + ','; });
    return s + '|' + c.total_price;
  }
  function anyBusy() { for (var k in busy) { if (busy[k]) return true; } return false; }
  function rootVisible(root) {
    if (root.getAttribute('data-yn-cart-root') === 'page') return true;
    return !root.hidden && root.getClientRects().length > 0;
  }

  d.addEventListener('yuno:cart', function (e) {
    var cart = (e.detail && e.detail.cart) || (Y.cart && Y.cart.state);
    if (!cart || !cart.items) return;
    lastCart = cart;
    if (!cartRoots().length || anyBusy()) return;
    syncCart(cart);
  });
  d.addEventListener('yuno:cart:added', function (e) {
    var it = e.detail && e.detail.items && e.detail.items[0];
    if (it) { hl = String(it.id || it.variant_id || ''); if (!renderingSig) setTimeout(function () { highlightPending(); }, 60); }
  });
  var renderHold = 0;   /* after a suggestion's own button was tapped, the cart waits for its tick and arc before it redraws */
  function syncCart(cart) {
    var sig = sigOf(cart);
    var stale = cartRoots().some(function (r) { return r.getAttribute('data-sig') !== sig; });
    if (!stale || sig === renderingSig) return;
    var wait0 = renderHold - Date.now();
    if (wait0 > 0) { setTimeout(function () { var c = (Y.cart && Y.cart.state) || cart; if (!anyBusy()) syncCart(c); }, wait0 + 30); return; }
    renderCart(sig);
  }

  function renderCart(sig) {
    var roots = cartRoots();
    if (!roots.length) return Promise.resolve();
    var ids = [];
    roots.forEach(function (r) { var s = r.getAttribute('data-yn-section'); if (s && ids.indexOf(s) < 0) ids.push(s); });
    var seq = ++cartSeq;
    renderingSig = sig;
    var base = routes().root || '/';   /* not the cart url: there, an Accept: application/json header returns the cart itself */
    var p = fetch(base + (base.indexOf('?') > -1 ? '&' : '?') + 'sections=' + ids.join(','), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('render'); return r.json(); })
      .then(function (json) {
        if (seq !== cartSeq) return;
        renderingSig = null;
        cartRoots().forEach(function (root) {
          var html = json[root.getAttribute('data-yn-section')];
          if (html) applySection(root, html);
        });
      })
      .catch(function (err) { if (seq === cartSeq) renderingSig = null; if (window.console) console.warn('yn-shop: could not redraw the cart', err); });
    renderPromise = p;
    return p;
  }

  function snapshot(root) {
    var s = { sub: null, gap: null, state: null, lines: {}, focus: null, note: null };
    var sub = $('[data-yn-subtotal]', root); if (sub) s.sub = Number(sub.getAttribute('data-cents'));
    var ship = $('[data-yn-ship]', root); if (ship) { s.gap = Number(ship.getAttribute('data-gap')); s.state = ship.getAttribute('data-state'); }
    $$('.yn-line', root).forEach(function (li) { s.lines[li.getAttribute('data-yn-line')] = { cents: Number(li.getAttribute('data-line-cents')), qty: Number(li.getAttribute('data-qty')) }; });
    var ae = d.activeElement;
    if (ae && ae !== d.body && root.contains(ae)) {
      var li = ae.closest ? ae.closest('.yn-line') : null;
      s.focus = {
        key: li ? li.getAttribute('data-yn-line') : null,
        act: ae.hasAttribute('data-yn-qty') ? 'qty:' + ae.getAttribute('data-yn-qty') : ae.hasAttribute('data-yn-remove') ? 'remove' : ae.hasAttribute('data-yn-note-toggle') ? 'note' : ae.hasAttribute('data-yn-note') ? 'text' : null,
        sel: ae.hasAttribute('data-yn-note') ? [ae.selectionStart, ae.selectionEnd] : null
      };
    }
    var nt = $('[data-yn-note]', root);
    if (nt) { var pn = $('.yn-note__panel', root); s.note = { value: nt.value, open: !!(pn && pn.classList.contains('is-open')) }; }
    return s;
  }

  function swapBody(o, n) {
    var os = o.querySelector(':scope > [data-yn-ship]'), ns = n.querySelector(':scope > [data-yn-ship]');
    if (os && ns) {
      /* keep the live ship bar so its fill and truck can travel to the new position */
      os.className = ns.className;
      ['data-state', 'data-gap', 'style'].forEach(function (a) { os.setAttribute(a, ns.getAttribute(a) || ''); });
      var om = $('[data-yn-ship-msg]', os), nm = $('[data-yn-ship-msg]', ns);
      if (om && nm) om.innerHTML = nm.innerHTML;
      while (os.nextSibling) o.removeChild(os.nextSibling);
      while (ns.nextSibling) o.appendChild(ns.nextSibling);
      while (os.previousSibling) o.removeChild(os.previousSibling);
      var before = [], x = ns.previousSibling;
      while (x) { before.unshift(x); x = x.previousSibling; }
      before.forEach(function (node) { o.insertBefore(node, os); });
    } else {
      o.innerHTML = n.innerHTML;
    }
  }

  function applySection(root, html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nroot = doc.querySelector('[data-yn-cart-root="' + root.getAttribute('data-yn-cart-root') + '"]');
    if (!nroot) return;
    var prev = snapshot(root);
    ['count', 'body', 'foot'].forEach(function (name) {
      var o = $('[data-yn-cart-region="' + name + '"]', root), n = $('[data-yn-cart-region="' + name + '"]', nroot);
      if (!o || !n) return;
      if (name === 'body') swapBody(o, n);
      else { o.innerHTML = n.innerHTML; if (name === 'foot') o.hidden = n.hasAttribute('hidden'); }
    });
    root.setAttribute('data-sig', nroot.getAttribute('data-sig') || '');
    afterRender(root, prev);
  }

  function highlight(root) {
    if (!hl || !root || reduced()) { if (reduced()) hl = null; return; }
    var li = $$('.yn-line', root).filter(function (l) { return l.getAttribute('data-variant') === String(hl); })[0];
    if (!li) return;
    anim(li, [{ backgroundColor: 'rgba(254,206,0,.45)' }, { backgroundColor: 'rgba(254,206,0,0)' }], { duration: 800, easing: 'ease-out' });
    hl = null;
  }
  function highlightPending() {
    cartRoots().forEach(function (r) { if (hl && rootVisible(r)) highlight(r); });
  }

  function celebrate(root) {
    var done = false;
    try { done = sessionStorage.getItem('yuno-celebrated') === '1'; } catch (e) {}
    if (done || !isEG()) return;
    try { sessionStorage.setItem('yuno-celebrated', '1'); } catch (e) {}
    if (reduced()) return;
    setTimeout(function () {
      var tr = $('[data-yn-truck]', root);
      if (tr) {
        anim(tr, [{ transform: 'translateY(0)' }, { transform: 'translateY(-12px) rotate(-8deg)' }, { transform: 'translateY(0)' }, { transform: 'translateY(-5px)' }, { transform: 'translateY(0)' }], { duration: 700, easing: 'ease-out' });
        var r = tr.getBoundingClientRect();
        burst(r.left + r.width / 2, r.top + r.height / 2);
      }
      hop($('[data-yn-cart-buddy]', root));
    }, 650);
  }

  function restoreFocus(root, f) {
    var scope = root;
    if (f.key) scope = $$('.yn-line', root).filter(function (l) { return l.getAttribute('data-yn-line') === f.key; })[0];
    if (!scope) return;
    var el = null;
    if (f.act === 'remove') el = $('[data-yn-remove]', scope);
    else if (f.act && f.act.indexOf('qty:') === 0) el = $('[data-yn-qty="' + f.act.slice(4) + '"]', scope);
    else if (f.act === 'note') el = $('[data-yn-note-toggle]', scope);
    else if (f.act === 'text') el = $('[data-yn-note]', scope);
    if (el && !el.disabled) {
      try { el.focus({ preventScroll: true }); if (f.sel && el.setSelectionRange) el.setSelectionRange(f.sel[0], f.sel[1]); } catch (e) {}
    }
  }

  function afterRender(root, prev) {
    var vis = rootVisible(root);
    var subEl = $('[data-yn-subtotal]', root);
    if (subEl) {
      var to = Number(subEl.getAttribute('data-cents'));
      if (prev.sub != null && prev.sub !== to && vis) countTo(subEl, prev.sub, to, money, 500);
    }
    var ship = $('[data-yn-ship]', root), state = ship ? ship.getAttribute('data-state') : null;
    if (ship) {
      var gap = Number(ship.getAttribute('data-gap')), gapEl = $('[data-yn-gap-amount]', ship);
      if (gapEl && prev.gap != null && prev.gap !== gap && vis) countTo(gapEl, prev.gap, gap, money, 600);
      if (prev.gap == null && vis && !reduced()) {
        /* the bar just appeared: let it grow from empty */
        var target = ship.getAttribute('style') || '';
        ship.style.setProperty('--yn-p', '0');
        void ship.offsetWidth;
        requestAnimationFrame(function () { ship.setAttribute('style', target); });
      }
      var truck = $('[data-yn-truck]', ship);
      if (truck && vis && prev.sub != null && subEl && prev.sub !== Number(subEl.getAttribute('data-cents'))) {
        anim(truck, [{ transform: 'translateY(0) rotate(0)' }, { transform: 'translateY(-4px) rotate(-6deg)' }, { transform: 'translateY(0) rotate(0)' }], { duration: 500, easing: SPRING });
      }
    }
    $$('.yn-line', root).forEach(function (li) {
      var k = li.getAttribute('data-yn-line'), pr = prev.lines[k], cents = Number(li.getAttribute('data-line-cents'));
      if (pr && pr.cents !== cents && vis) countTo($('[data-yn-line-price]', li), pr.cents, cents, money, 500);
    });
    if (hl && vis) highlight(root);
    if (isEG() && state === 'reached' && prev.state !== 'reached') {
      if (vis) celebrate(root); else celebratePending = true;
    }
    /* keep what she was typing, and the note panel as she left it */
    var nt = $('[data-yn-note]', root);
    if (nt && prev.note) {
      if (prev.note.value !== nt.value) nt.value = prev.note.value;
      if (prev.note.open) {
        var pn = $('.yn-note__panel', root), btn = $('[data-yn-note-toggle]', root);
        if (pn) pn.classList.add('is-open');
        if (btn) btn.setAttribute('aria-expanded', 'true');
      }
    }
    if (prev.focus) restoreFocus(root, prev.focus);
    refreshSuggLabels(root);
    var st = $('[data-yn-cart-status]', root);
    if (st && lastCart) {
      var cn = lastCart.item_count;
      st.textContent = !cn ? T('Your cart is empty')
        : cn === 1 ? T('Cart updated: [n] piece, subtotal [a]', { n: cn, a: money(lastCart.total_price) })
        : T('Cart updated: [n] pieces, subtotal [a]', { n: cn, a: money(lastCart.total_price) });
    }
  }

  d.addEventListener('yuno:sheet:open', function (e) {
    var id = e.detail && e.detail.id;
    if (id !== 'yn-sheet-cart') return;
    var root = $('#yn-sheet-cart'); if (!root) return;
    if (hl) setTimeout(function () { highlight(root); }, 380);
    if (celebratePending) { celebratePending = false; setTimeout(function () { celebrate(root); }, 380); }
  });

  /* ----- line changes: stepper (coalesced, optimistic) and remove with undo ----- */
  function parseProps(s) {
    try { var o = JSON.parse(s || '{}'); return o && !Array.isArray(o) && typeof o === 'object' ? o : {}; } catch (e) { return {}; }
  }
  function finishKey(key, failed) {
    delete qq[key]; delete busy[key];
    if (anyBusy()) return;
    var c = (Y.cart && Y.cart.state) || lastCart;
    if (!c) return;
    if (failed) renderCart(sigOf(c)); else syncCart(c);
  }
  function pump(key) {
    var q = qq[key];
    if (!q || q.busy) return;
    if (q.want === q.sent) { finishKey(key); return; }
    q.busy = true;
    var target = q.want;
    q.p = Promise.resolve(cartChange(key, target)).then(function () {
      q.sent = target; q.busy = false; pump(key);
    }, function (e) {
      q.busy = false; q.want = q.sent;
      toast(errMsg(e, 'Couldn’t change that. Check your connection and try again.'), { ms: 4200 });
      finishKey(key, true);
    });
  }
  function changeQty(li, delta, btn) {
    var key = li.getAttribute('data-yn-line');
    var q = qq[key];
    if (q && q.removing) return;
    if (!q) { var n0 = Number(li.getAttribute('data-qty')); q = qq[key] = { want: n0, sent: n0, busy: false }; }
    var next = q.want + delta;
    if (next < 1) { removeLine(li, q.want); return; }
    var max = Number(li.getAttribute('data-max')) || 0;
    if (max && next > max) { shake(btn, 3); return; }
    q.want = next;
    var numEl = $('[data-yn-qty-num]', li);
    if (numEl) {
      numEl.textContent = String(next);
      if (!reduced()) anim(numEl, [{ transform: 'translateY(' + (delta > 0 ? 10 : -10) + 'px)', opacity: 0 }, { transform: 'none', opacity: 1 }], { duration: 220, easing: OUT });
    }
    var plus = $('[data-yn-qty="1"]', li); if (plus && max) plus.disabled = next >= max;
    busy[key] = true;
    pump(key);
  }
  function collapse(li) {
    if (reduced() || !li.animate) return Promise.resolve();
    li.style.overflow = 'hidden';
    var a = anim(li, [
      { height: li.offsetHeight + 'px', paddingTop: '12px', paddingBottom: '12px', opacity: 1 },
      { height: '0px', paddingTop: '0px', paddingBottom: '0px', opacity: 0 }
    ], { duration: 220, easing: IN, fill: 'forwards' });
    return a ? Promise.race([a.finished.then(function () {}, function () {}), wait(320)]) : Promise.resolve();
  }
  function removeLine(li, qty) {
    var key = li.getAttribute('data-yn-line');
    var info = {
      variant: Number(li.getAttribute('data-variant')), qty: qty || Number(li.getAttribute('data-qty')) || 1,
      title: li.getAttribute('data-title') || '', img: li.getAttribute('data-img') || '', props: parseProps(li.getAttribute('data-props'))
    };
    var prior = qq[key] && qq[key].p;
    qq[key] = { removing: true, want: 0, sent: 0, busy: true };
    busy[key] = true;
    Promise.resolve(prior).then(function () { return collapse(li); }).then(function () { return cartChange(key, 0); }).then(function () {
      toast(T('Removed'), {
        photo: info.img, sub: info.title, actionLabel: T('Undo'), ms: 5000,
        onAction: function () {
          hl = String(info.variant);
          cartAdd([{ id: info.variant, quantity: info.qty, properties: info.props }], { source: 'undo' }).catch(function (e) { toast(errMsg(e), { ms: 4200 }); });
        }
      });
      finishKey(key);
    }, function (e) {
      toast(errMsg(e, 'Couldn’t remove that. Check your connection and try again.'), { ms: 4200 });
      finishKey(key, true);
    });
  }

  function toggleNote(btn) {
    var root = btn.closest('[data-yn-cart-root]'); if (!root) return;
    var panel = $('.yn-note__panel', root); if (!panel) return;
    var open = !panel.classList.contains('is-open');
    panel.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', String(open));
    if (open) {
      var t = $('[data-yn-note]', panel);
      setTimeout(function () { if (t) { try { t.focus({ preventScroll: true }); t.scrollIntoView({ block: 'nearest', behavior: reduced() ? 'auto' : 'smooth' }); } catch (e) {} } }, reduced() ? 0 : 280);
    }
  }
  function saveNote(v) {
    if (v === lastNote) return;
    lastNote = v;
    Promise.resolve(cartNote(v)).catch(function () {});
  }

  function openCart(opts) {
    var page = $('[data-yn-cart-root="page"]');
    if (page) { page.scrollIntoView({ block: 'start', behavior: reduced() ? 'auto' : 'smooth' }); return true; }
    var go = function () { sheetOpen('yn-sheet-cart', opts); };
    /* if the sheet is still redrawing after an add, give it a moment so it never rises showing the old cart */
    if (renderingSig && renderPromise) Promise.race([renderPromise, wait(500)]).then(go); else go();
    return true;
  }
  function closeCart() { sheetClose('yn-sheet-cart'); }
  function assignApi() {
    Y.cart = Y.cart || {};
    Y.cart.open = openCart;
    Y.cart.close = closeCart;
    Y.quickAdd = Y.quickAdd || {};
    Y.quickAdd.open = quickOpen;
  }

  /* ----- suggestion + "complete the look": adding goes through quick add (a remembered size adds straight away when there is nothing else to choose) ----- */
  function parseMap(s) {
    var m = {};
    String(s || '').split(';').forEach(function (kv) { var i = kv.lastIndexOf(':'); if (i > 0) m[kv.slice(0, i)] = kv.slice(i + 1); });
    return m;
  }
  function refreshSuggLabels(scope) {
    var sz = sizeGet();
    $$('.yn-sugg__add[data-yn-sizes]', scope).forEach(function (b) {
      var m = parseMap(b.getAttribute('data-yn-sizes'));
      b.textContent = sz && m[sz] ? T('+ Add · [n]', { n: T(sz) }) : T('+ Add');
    });
  }
  function directAdd(btn, variantId) {
    var holder = btn.closest('.yn-sugg'), im = holder && $('img', holder), src = im ? (im.currentSrc || im.src) : '';
    renderHold = Date.now() + 1500;   /* the cart redraws after the tick and the arc, as in the prototype */
    var pr = cartAdd([{ id: Number(variantId), quantity: 1 }], { source: 'cart' });
    pr.then(function () { renderHold = Date.now() + 1100; }, function () { renderHold = 0; });
    runAdd(btn, pr, src).then(function () { renderHold = 0; var c = (Y.cart && Y.cart.state) || lastCart; if (c && !anyBusy()) syncCart(c); }, function () { renderHold = 0; });
  }
  function onCartAdd(btn) {
    var handle = btn.getAttribute('data-yn-cart-add'), map = parseMap(btn.getAttribute('data-yn-sizes')), sz = sizeGet();
    if (sz && map[sz]) { directAdd(btn, map[sz]); return; }
    quickOpen(handle, { from: 'cart' });
  }

  /* ================= QUICK ADD ================= */
  var Q = { token: 0, cache: {}, data: null, colour: null, size: null, opts: {}, phase: 'idle', skHtml: null, skTimer: null, fail: null };

  function productUrl(handle) {
    var root = routes().root || '/';
    if (root.charAt(root.length - 1) === '/') root = root.slice(0, -1);
    return root + '/products/' + encodeURIComponent(handle);
  }

  function cssColour(name) {
    var n = String(name || '').toLowerCase(), map = [['sky blue', '#87ceeb'], ['light blue', '#add8e6'], ['navy', '#1f2a44'], ['blue', '#0040ea'], ['cyan', '#2bc4d8'], ['black', '#1f1f1f'], ['white', '#ffffff'], ['cream', '#f5efe0'], ['beige', '#d9c6a5'], ['sage', '#a9b79a'], ['green', '#1f9a5b'], ['yellow', '#fece00'], ['orange', '#ff6a1a'], ['pink', '#f49ac1'], ['lavender', '#c8b6e8'], ['purple', '#8a63c9'], ['red', '#e5322d'], ['brown', '#8b5a3c'], ['gr', '#b8b8b8']];
    for (var i = 0; i < map.length; i++) { if (n.indexOf(map[i][0]) > -1) return map[i][1]; }
    return '';
  }

  function prep(raw) {
    var D = { handle: raw.handle, title: raw.title, url: raw.url, available: !!raw.available, image: raw.image || null };
    D.sizeIdx = -1; D.colourIdx = -1; D.generic = false;
    (raw.options || []).forEach(function (o, i) {
      /* option names are translated on /ar (مقاس, لون), the values are not */
      var n = String(o.name || '').toLowerCase().trim();
      if (D.sizeIdx < 0 && /^(size|sizes|مقاس|المقاس)$/.test(n)) D.sizeIdx = i;
      else if (D.colourIdx < 0 && /^(color|colour|لون|اللون)$/.test(n)) D.colourIdx = i;
    });
    if (D.sizeIdx < 0) {
      for (var i = 0; i < (raw.options || []).length; i++) {
        if (i !== D.colourIdx && raw.options[i].values.length > 1) { D.sizeIdx = i; D.generic = true; break; }
      }
    }
    D.variants = (raw.variants || []).map(function (v) {
      var sr = D.sizeIdx > -1 ? v.o[D.sizeIdx] : '';
      return {
        id: v.id, o: v.o, available: !!v.available, price: Number(v.price) || 0, compare: Number(v.compare) || 0, qty: v.qty ? Number(v.qty) : null, img: v.image || null,
        size: D.sizeIdx > -1 ? (D.generic ? String(sr) : normSize(sr)) : '',
        colour: D.colourIdx > -1 ? String(v.o[D.colourIdx]) : ''
      };
    }).filter(function (v) { return D.sizeIdx < 0 || D.generic || v.size; });
    D.sizes = [];
    if (D.sizeIdx > -1) {
      if (D.generic) raw.options[D.sizeIdx].values.forEach(function (val) { D.sizes.push(String(val.v)); });
      else sizes().forEach(function (s) { if (D.variants.some(function (v) { return v.size === s; })) D.sizes.push(s); });
    }
    D.colours = [];
    if (D.colourIdx > -1) {
      raw.options[D.colourIdx].values.forEach(function (val) {
        var name = String(val.v), vs = D.variants.filter(function (v) { return v.colour === name; });
        var withImg = vs.filter(function (v) { return v.img && v.available; })[0] || vs.filter(function (v) { return v.img; })[0];
        D.colours.push({ name: name, css: String(val.css || ''), img: withImg ? withImg.img : null, avail: vs.some(function (v) { return v.available; }) });
      });
    }
    return D;
  }
  function fromJs(p) {
    var opts = (p.options || []).map(function (o, i) {
      if (typeof o === 'string') {
        var seen = [], vals = [];
        (p.variants || []).forEach(function (v) { var x = v.options[i]; if (seen.indexOf(x) < 0) { seen.push(x); vals.push({ v: x }); } });
        return { name: o, values: vals };
      }
      return { name: o.name, values: (o.values || []).map(function (x) { return { v: x }; }) };
    });
    return {
      handle: p.handle, title: p.title, url: p.url, available: p.available, image: p.featured_image || null, options: opts,
      variants: (p.variants || []).map(function (v) {
        return { id: v.id, o: v.options || [], available: v.available, price: v.price, compare: v.compare_at_price || 0, qty: null, image: v.featured_image && (v.featured_image.src || v.featured_image) || null };
      })
    };
  }
  function loadProduct(handle) {
    if (Q.cache[handle]) return Promise.resolve(Q.cache[handle]);
    var url = productUrl(handle);
    return fetch(url + '?section_id=yn-quick-data', { credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error('data'); return r.text(); })
      .then(function (html) {
        var s = new DOMParser().parseFromString(html, 'text/html').querySelector('script[data-yn-quick-data]');
        if (!s) throw new Error('no data');
        return JSON.parse(s.textContent);
      })
      .catch(function () {
        return fetch(url + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw new Error('js'); return r.json(); }).then(fromJs);
      })
      .then(function (raw) { var D = prep(raw); Q.cache[handle] = D; return D; });
  }

  function variantFor(colour, size) {
    var D = Q.data; if (!D) return null;
    var list = D.variants.filter(function (v) {
      return (D.colourIdx < 0 || v.colour === colour) && (D.sizes.length === 0 || v.size === size);
    });
    return list.filter(function (v) { return v.available; })[0] || list[0] || null;
  }
  function isPick() { return Q.opts.mode === 'pick' || Q.opts.from === 'bundle'; }
  function addState() {
    var D = Q.data; if (!D) return 'need';
    if (D.sizes.length && !Q.size) return 'need';
    var v = variantFor(Q.colour, Q.size);
    return v && v.available ? 'ready' : 'out';
  }
  function photoSrc() {
    var D = Q.data, c = D.colours.filter(function (x) { return x.name === Q.colour; })[0];
    var v = D.sizes.length && Q.size ? variantFor(Q.colour, Q.size) : null;
    return (v && v.img) || (c && c.img) || D.image || '';
  }
  function setErr(t) { var e = $('[data-yn-q-err]'); if (e) e.textContent = t || ''; }

  function showSkeleton() {
    var body = $('[data-yn-q-body]'); if (!body) return;
    if (Q.skHtml == null) Q.skHtml = body.innerHTML;
    body.innerHTML = Q.skHtml;
    body.setAttribute('aria-busy', 'true');
    clearTimeout(Q.skTimer);
    Q.skTimer = setTimeout(function () { var b = $('[data-yn-q-buddy]'); if (b) b.hidden = false; }, 400);
    var t = $('[data-yn-q-title]'); if (t) t.textContent = T('Quick add');
    Q.fail = null; setErr('');
    setAddUI();
  }
  function showFail(handle) {
    clearTimeout(Q.skTimer);
    var body = $('[data-yn-q-body]'); if (!body) return;
    body.setAttribute('aria-busy', 'false');
    body.innerHTML = '<div class="yn-q__fail">' + TH('Couldn’t load that one.') + ' <a href="' + esc(productUrl(handle)) + '">' + TH('Open the product page') + '</a></div>';
    Q.fail = handle; setAddUI();
  }

  /* the add button's resting states: choose a size / tell me when it's back / add to cart. Loading, ticking and failing belong to Yuno.addButton. */
  function setAddUI() {
    var btn = $('[data-yn-q-add]'); if (!btn || Q.phase === 'adding') return;
    var st, label;
    if (Q.fail) { st = 'out'; label = T('Open the product'); }
    else if (!Q.data) { st = 'need'; label = T('Choose a size'); }
    else {
      st = addState();
      if (st === 'need') label = T('Choose a size');
      else if (st === 'out') label = T('Tell me when it’s back');
      else if (isPick()) label = Q.size ? T('Use [n]', { n: T(Q.size) }) : T('Use');
      else label = Q.size ? T('Add to cart · [n]', { n: T(Q.size) }) : T('Add to cart');
    }
    btn.innerHTML = '<span>' + esc(label) + '</span>';
    btn.setAttribute('data-state', st);
  }
  function swatchStyle(c) {
    /* c.css comes from the shared yn-colour snippet, so the dot matches the cards; the name map is only the fallback */
    if (c.css) return '--yn-swatch:' + esc(c.css);
    var n = cssColour(c.name);
    return n ? '--yn-swatch:' + n : '';
  }
  function buildQuick() {
    var D = Q.data, body = $('[data-yn-q-body]'); if (!body) return;
    clearTimeout(Q.skTimer);
    var h = '<div class="yn-q__top" data-yn-si><img class="yn-q__photo" data-yn-q-photo src="' + esc(photoSrc()) + '" alt="" width="96" height="120">' +
      '<div class="yn-q__info"><span class="yn-q__name">' + esc(D.title) + '</span>' +
      '<span class="yn-q__price"><span class="yn-q__now" data-yn-q-now></span><s class="yn-q__was" data-yn-q-was></s></span>' +
      (isPick() ? '' : '<a class="yn-q__details" href="' + esc(D.url) + '">' + TH('See all details') + '</a>') + '</div></div>';
    if (D.colours.length > 1) {
      h += '<div class="yn-q__colour" data-yn-si><div class="yn-q__colour-label">' + TH('Colour: [n]', { n: '<b data-yn-q-colour></b>' }) + '</div><div class="yn-q__swatches" role="group" aria-label="' + TH('Colour') + '">';
      D.colours.forEach(function (c) {
        h += '<button type="button" class="yn-q__sw' + (c.avail ? '' : ' is-out') + '" data-colour="' + esc(c.name) + '" aria-label="' + esc(c.avail ? c.name : T('[a], sold out', { a: c.name })) + '" aria-pressed="false">' +
          '<span class="yn-q__sw-dot" style="' + swatchStyle(c) + '"></span><span class="yn-q__sw-ring"></span><span class="yn-q__sw-strike"></span></button>';
      });
      h += '</div></div>';
    }
    if (D.sizes.length) {
      /* the pill's data-size is the key (English); only the text on it is translated */
      h += '<div class="yn-q__label" data-yn-si>' + TH('Size') + '</div><div class="yn-q__pills" data-yn-si data-yn-q-pills role="group" aria-label="' + TH('Size') + '">';
      D.sizes.forEach(function (s) { h += '<button type="button" class="yn-q__pill" data-size="' + esc(s) + '" aria-pressed="false">' + esc(T(s)) + '</button>'; });
      h += '</div>';
    }
    h += '<p class="yn-q__line" data-yn-si data-yn-q-line></p>';
    body.innerHTML = h;
    body.setAttribute('aria-busy', 'false');
    var t = $('[data-yn-q-title]'); if (t) t.textContent = T('Quick add: [n]', { n: D.title });
    updateQuick();
    if (!reduced()) {
      $$('[data-yn-si]', body).forEach(function (el, i) {
        anim(el, [{ opacity: 0, transform: 'translateY(14px)' }, { opacity: 1, transform: 'none' }], { duration: 300, delay: 100 + Math.min(i, 6) * 40, easing: OUT, fill: 'backwards' });
      });
    }
  }
  function updateQuick(change) {
    var D = Q.data; if (!D) return;
    $$('.yn-q__sw').forEach(function (sw) { sw.setAttribute('aria-pressed', String(sw.getAttribute('data-colour') === Q.colour)); });
    var cl = $('[data-yn-q-colour]'); if (cl) cl.textContent = Q.colour || '';
    var ph = $('[data-yn-q-photo]'), src = photoSrc();
    if (ph && src && ph.getAttribute('src') !== src) {
      ph.setAttribute('src', src);
      if (change === 'colour' && !reduced()) anim(ph, [{ opacity: 0.2 }, { opacity: 1 }], { duration: 180 });
    }
    $$('.yn-q__pill').forEach(function (p) {
      var s = p.getAttribute('data-size'), vv = variantFor(Q.colour, s), out = !vv || !vv.available;
      var n = vv && vv.available && vv.qty && vv.qty <= lowStock() ? vv.qty : 0;
      p.classList.toggle('is-soldout', out);
      p.setAttribute('aria-pressed', String(Q.size === s));
      p.setAttribute('aria-label', out ? T('[a], sold out', { a: T(s) }) : n ? T('[a], [n] left', { a: T(s), n: n }) : T(s));
      var low = $('.yn-q__low', p);
      if (n) { if (!low) { low = d.createElement('span'); low.className = 'yn-q__low'; low.setAttribute('aria-hidden', 'true'); p.appendChild(low); } low.textContent = T('[n] left', { n: n }); }
      else if (low) low.remove();
    });
    /* price: the chosen variant's, otherwise the lowest in the chosen colour */
    var pv = (D.sizes.length && Q.size ? variantFor(Q.colour, Q.size) : null);
    if (!pv) {
      var pool = D.variants.filter(function (v) { return D.colourIdx < 0 || v.colour === Q.colour; });
      var avail = pool.filter(function (v) { return v.available; });
      pool = (avail.length ? avail : pool).slice().sort(function (a, b) { return a.price - b.price; });
      pv = pool[0] || null;
    }
    var now = $('[data-yn-q-now]'), was = $('[data-yn-q-was]');
    if (now && pv) {
      now.textContent = money(pv.price);
      now.classList.toggle('is-regular', !(pv.compare > pv.price));
      if (was) { was.textContent = pv.compare > pv.price ? money(pv.compare) : ''; }
    }
    var line = $('[data-yn-q-line]');
    if (line) {
      var txt = '', bad = false;
      if (D.sizes.length) {
        if (!Q.size) txt = T('Psst… we run roomy!');
        else {
          var v2 = variantFor(Q.colour, Q.size);
          if (!v2 || !v2.available) { txt = T('Sold out in [n]', { n: T(Q.size) }); bad = true; }
          else if (v2.qty && v2.qty <= lowStock()) txt = T('Only [n] left', { n: v2.qty });
        }
      }
      line.textContent = txt;
      line.classList.toggle('is-bad', bad);
    }
    setAddUI();
  }

  function quickOpen(handle, opts) {
    if (!handle) return;
    var sheet = $('#yn-sheet-quick');
    if (!sheet) { location.href = productUrl(handle); return; }
    var token = ++Q.token;
    Q.opts = opts || {}; Q.data = null; Q.colour = null; Q.size = null; Q.phase = 'idle';
    showSkeleton();
    sheetOpen('yn-sheet-quick', { opener: Q.opts.opener });
    loadProduct(handle).then(function (D) {
      if (token !== Q.token) return;
      Q.data = D;
      if (D.colourIdx > -1) {
        var want = Q.opts.colour, c = null;
        if (want != null) c = D.colours.filter(function (x, i) { return String(x.name).toLowerCase() === String(want).toLowerCase() || i === want; })[0];
        if (!c) c = D.colours.filter(function (x) { return x.avail; })[0] || D.colours[0];
        Q.colour = c ? c.name : null;
      }
      var s = Q.opts.size ? (normSize(Q.opts.size) || String(Q.opts.size)) : sizeGet();
      if (s && D.sizes.indexOf(s) > -1) {
        var v = variantFor(Q.colour, s);
        if (Q.opts.size || (v && v.available)) Q.size = s;
      }
      buildQuick();
    }, function () { if (token === Q.token) showFail(handle); });
  }

  function onQuickAdd() {
    if (Q.fail) { location.href = productUrl(Q.fail); return; }
    if (!Q.data || Q.phase === 'adding') return;
    var st = addState();
    if (st === 'need') { shake($('[data-yn-q-pills]'), 4); setErr(''); return; }
    if (st === 'out') {
      window.open(wa(Q.size ? T('Hi Yuno! Please tell me when "[a]" in [b] is back.', { a: Q.data.title, b: T(Q.size) }) : T('Hi Yuno! Please tell me when "[a]" in my size is back.', { a: Q.data.title })), '_blank');
      return;
    }
    var v = variantFor(Q.colour, Q.size), prod = Q.data, opts = Q.opts, size = Q.size, token = Q.token;
    if (isPick()) {
      var cb = opts.onPick;
      sheetClose('yn-sheet-quick');
      if (typeof cb === 'function') cb({ variantId: v.id, size: size, colour: Q.colour, variant: v, product: prod });
      return;
    }
    var btn = $('[data-yn-q-add]'), photo = photoSrc(), errEl = $('[data-yn-q-err]');
    Q.phase = 'adding'; setErr('');
    var pr = cartAdd([{ id: v.id, quantity: 1 }], { source: 'quick' });
    runAdd(btn, pr, photo, { errorEl: errEl }).then(function () {
      delete Q.cache[prod.handle];
      Q.phase = 'idle';
      if (token === Q.token) sheetClose('yn-sheet-quick');
      if (opts.from !== 'cart') {
        toast(T('Added!'), {
          photo: photo, sub: money(v.price) + (size ? ' · ' + T(size) : ''), actionLabel: T('View cart'), ms: 4200,
          onAction: function () { if (Y.cart && Y.cart.open) Y.cart.open(); else openCart(); }
        });
      }
    }, function (e) {
      Q.phase = 'idle';
      if (typeof Y.addButton !== 'function') setErr(errMsg(e));
      setAddUI();
    });
  }
  d.addEventListener('yuno:sheet:close', function (e) {
    var id = e.detail && e.detail.id;
    if (id === 'yn-sheet-quick' && Q.phase !== 'adding') { Q.phase = 'idle'; Q.token++; }
  });
  /* ================= COLLECTION ================= */
  var KIND_ORDER = ['t-shirts', 'shorts', 'pants', 'sets', 'sweatshirts'];
  var KIND_LABEL = { 't-shirts': 'T-shirts', shorts: 'Shorts', pants: 'Pants', sets: 'Sets', sweatshirts: 'Sweatshirts & hoodies' };   /* keys stay as they are; the label is what she reads (through T) */

  function setChildren(c, els) {
    var cur = Array.prototype.slice.call(c.children);
    if (cur.length === els.length && cur.every(function (x, i) { return x === els[i]; })) return;
    if (c.replaceChildren) c.replaceChildren.apply(c, els);
    else { while (c.firstChild) c.removeChild(c.firstChild); els.forEach(function (e) { c.appendChild(e); }); }
  }
  function parseCell(c) {
    var set = function (a) { return (c.getAttribute(a) || '').split('|').filter(Boolean); };
    var o = {
      el: c, pos: Number(c.getAttribute('data-pos')) || 0, avail: c.getAttribute('data-avail') === 'true',
      price: Number(c.getAttribute('data-price')) || 0, compare: Number(c.getAttribute('data-compare')) || 0,
      kind: c.getAttribute('data-kind') || '', has: set('data-has'), inS: set('data-in'), title: c.getAttribute('data-title') || ''
    };
    o.saving = o.compare > o.price ? (o.compare - o.price) / o.compare : 0;
    c.__yn = o;
    return o;
  }

  function initColl(el) {
    if (!el || el.__ynColl) return;
    el.__ynColl = true;
    var grid = $('[data-yn-grid]', el);
    if (!grid) { de.classList.remove('yn-has-size'); return; }
    var soldWrap = $('[data-yn-sold]', el), soldGrid = $('[data-yn-sold-grid]', el), soldLabel = $('[data-yn-sold-label]', el), soldBtn = $('[data-yn-sold-toggle]', el);
    var park = $('[data-yn-park]', el), more = $('[data-yn-more]', el), allOutEl = $('[data-yn-allout]', el), altsGrid = $('[data-yn-alts]', el), altsTitle = $('[data-yn-alts-title]', el);
    var countEl = $('[data-yn-count]', el), chipsEl = $('[data-yn-chips]', el), bar = $('[data-yn-coll-bar]', el);
    var sheet = $('#yn-sheet-filters');
    var pageSize = Number(el.getAttribute('data-page-size')) || 8, collTitle = el.getAttribute('data-title') || '';   /* the collection's own title, as the shop wrote it */
    var cells = $$('[data-yn-cell]', el).filter(function (c) { return !c.hasAttribute('data-yn-alt'); }).map(parseCell);
    var alts = $$('[data-yn-alt]', el).map(parseCell);
    var fp = sheet && $('[data-yn-fprice]', sheet), lo = fp ? Number(fp.getAttribute('data-lo')) : 40000, hi = fp ? Number(fp.getAttribute('data-hi')) : 50000;
    var key = 'yn-coll:' + location.pathname;
    var DEF = { avail: false, price: '', type: '', sort: 'featured' };
    var st = { f: Object.assign({}, DEF), shown: pageSize, soldOpen: false };
    var lastNums = null;

    /* type filter: only when the collection spans more than one kind */
    var kinds = KIND_ORDER.filter(function (k) { return cells.some(function (c) { return c.kind === k; }); });
    if (sheet && kinds.length > 1) {
      var grp = $('[data-yn-ftype]', sheet), box = $('[data-yn-ftype-chips]', sheet);
      if (grp && box) {
        var th = '<button type="button" class="yn-fchip" data-yn-f="type" data-v="" aria-pressed="true">' + TH('All types') + '</button>';
        kinds.forEach(function (k) { th += '<button type="button" class="yn-fchip" data-yn-f="type" data-v="' + k + '" aria-pressed="false">' + TH(KIND_LABEL[k]) + '</button>'; });
        box.innerHTML = th; grp.hidden = false;
      }
    }

    function compute() {
      var size = sizeGet(), f = st.f;
      var inS = function (c) { return size && c.has.length ? c.inS.indexOf(size) > -1 : c.avail; };
      var ps = cells.filter(function (c) {
        if (size && c.has.length && c.has.indexOf(size) < 0) return false;   /* does not come in this size at all */
        if (f.type && c.kind !== f.type) return false;
        if (f.price === 'lo' && !(c.price < lo)) return false;
        if (f.price === 'mid' && !(c.price >= lo && c.price < hi)) return false;
        if (f.price === 'hi' && !(c.price >= hi)) return false;
        return true;
      });
      if (f.avail) ps = ps.filter(inS);
      var byPos = function (a, b) { return a.pos - b.pos; };
      if (f.sort === 'low') ps.sort(function (a, b) { return a.price - b.price || byPos(a, b); });
      else if (f.sort === 'high') ps.sort(function (a, b) { return b.price - a.price || byPos(a, b); });
      else if (f.sort === 'off') ps.sort(function (a, b) { return b.saving - a.saving || byPos(a, b); });
      else ps.sort(byPos);
      var a = [], o = [];
      ps.forEach(function (c) { (inS(c) ? a : o).push(c); });
      return { size: size, all: ps, inS: a, out: o, test: inS };
    }

    function fmtCount(n) { return '<span class="yn-num">' + n + '</span>'; }
    function render(o) {
      o = o || {};
      var L = compute(), size = L.size;
      var list = size ? L.inS : L.inS.concat(L.out);
      var allOut = L.inS.length === 0 && L.all.length > 0;
      var shown = list.slice(0, st.shown);
      var soldOn = !!size && L.out.length > 0 && !allOut;
      var soldShow = soldOn && st.soldOpen ? L.out : [];
      var keep = shown.concat(soldShow);

      cells.forEach(function (c) { if (keep.indexOf(c) < 0 && c.el.parentNode !== park) park.appendChild(c.el); });
      setChildren(grid, shown.map(function (c) { return c.el; }));
      soldWrap.hidden = !soldOn;
      if (soldOn) {
        soldLabel.textContent = T('Sold out in [n] ([a])', { n: T(size), a: L.out.length });
        soldBtn.setAttribute('aria-expanded', String(st.soldOpen));
        soldGrid.hidden = !st.soldOpen;
        setChildren(soldGrid, soldShow.map(function (c) { return c.el; }));
        soldShow.forEach(function (c) {
          var a = $('[data-yn-notify]', c.el);
          if (a) a.setAttribute('href', wa(T('Hi Yuno! Please tell me when "[a]" in [b] is back.', { a: c.title, b: T(size) })));
        });
      } else { soldGrid.hidden = true; setChildren(soldGrid, []); }
      more.hidden = !(list.length > st.shown);

      allOutEl.hidden = !allOut;
      if (allOut) {
        var subject = st.f.type ? T(KIND_LABEL[st.f.type]) : collTitle;
        $('[data-yn-allout-title]', el).textContent = size && L.all.some(function (c) { return c.avail; }) ? T('Nothing in [n] here right now', { n: T(size) }) : T('[n] are back soon', { n: subject });
        $('[data-yn-allout-wa]', el).setAttribute('href', wa(size ? T('Hi Yuno! Please tell me when [a] are back in [b].', { a: subject, b: T(size) }) : T('Hi Yuno! Please tell me when [a] are back.', { a: subject })));
      }
      var altList = allOut ? alts.filter(function (c) { return size && c.has.length ? c.inS.indexOf(size) > -1 : c.avail; }).slice(0, 4) : [];
      alts.forEach(function (c) { c.el.hidden = altList.indexOf(c) < 0; });
      altsGrid.hidden = altsTitle.hidden = !altList.length;

      /* result count: ticks to its new number */
      var nums = size ? [L.inS.length] : [L.all.length, L.inS.length];
      countEl.innerHTML = size ? TH('[a] in stock in [b]', { a: fmtCount(L.inS.length), b: esc(T(size)) }) : TH('[a] pieces · [b] in stock', { a: fmtCount(L.all.length), b: fmtCount(L.inS.length) });
      if (lastNums && o.animate && !reduced()) {
        $$('.yn-num', countEl).forEach(function (n, i) { if (lastNums[i] != null && lastNums[i] !== nums[i]) countTo(n, lastNums[i], nums[i], String, 400); });
      }
      lastNums = nums;
      syncUI(L);
      if (o.animate && !reduced()) {
        anim(grid, [{ opacity: 0.35 }, { opacity: 1 }], { duration: 260, easing: OUT });
        if (altsGrid && !altsGrid.hidden) anim(altsGrid, [{ opacity: 0.35 }, { opacity: 1 }], { duration: 260, easing: OUT });
      }
      grid.classList.add('is-ready');
    }

    function syncUI(L) {
      var size = L.size, f = st.f;
      $$('[data-yn-size-chip]', el).forEach(function (b) {
        var v = b.getAttribute('data-yn-size-chip');
        b.setAttribute('aria-pressed', String(size ? v === size : !v));
      });
      var n = (f.avail ? 1 : 0) + (f.price ? 1 : 0) + (f.type ? 1 : 0) + (f.sort !== 'featured' ? 1 : 0);
      $$('[data-yn-filter-count]').forEach(function (b) { b.textContent = n ? String(n) : ''; b.classList.toggle('is-on', n > 0); });
      if (sheet) {
        $$('[data-yn-f]', sheet).forEach(function (b) {
          var k = b.getAttribute('data-yn-f'), v = b.getAttribute('data-v');
          var on = k === 'avail' ? (f.avail ? v === '1' : v === '0') : f[k] === v;
          b.setAttribute('aria-pressed', String(on));
        });
        var al = $('[data-yn-avail-label]', sheet); if (al) al.textContent = size ? T('In stock in [n]', { n: T(size) }) : T('In stock only');
        var sh = $('[data-yn-fshow]', sheet); if (sh) sh.textContent = T('Show [n] pieces', { n: L.all.length });
      }
    }

    function centreChip() {
      if (!chipsEl) return;
      var on = $('[data-yn-size-chip][aria-pressed="true"]', chipsEl); if (!on) return;
      var cr = chipsEl.getBoundingClientRect(), br = on.getBoundingClientRect();
      var left = br.left - cr.left + chipsEl.scrollLeft - (chipsEl.clientWidth - br.width) / 2;
      /* right-to-left: scrollLeft runs from 0 (the start, on the right) down to a negative number */
      var rtl = window.getComputedStyle(chipsEl).direction === 'rtl', to = rtl ? Math.min(0, left) : Math.max(0, left);
      try { chipsEl.scrollTo({ left: to, behavior: reduced() ? 'auto' : 'smooth' }); } catch (e) { chipsEl.scrollLeft = to; }
    }
    function stickyTop() {
      if (!bar) return;
      var top = 0;
      if (window.matchMedia && window.matchMedia('(min-width: 990px)').matches) {
        var h = $('.yn-hdr') || $('header');
        for (var n = h, i = 0; n && n !== d.body && i < 4; n = n.parentElement, i++) {
          var p = window.getComputedStyle(n).position;
          if (p === 'sticky' || p === 'fixed') { top = n.getBoundingClientRect().height; break; }
        }
      }
      bar.style.setProperty('--yn-coll-top', top + 'px');
    }

    /* keeping her place */
    function save() {
      try { sessionStorage.setItem(key, JSON.stringify({ shown: st.shown, f: st.f, soldOpen: st.soldOpen, y: window.pageYOffset || 0 })); } catch (e) {}
    }
    function restore() {
      var nav = window.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      if (!nav || nav.type !== 'back_forward') return false;
      var s = null;
      try { s = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) {}
      if (!s) return false;
      st.f = Object.assign({}, DEF, s.f || {});
      st.shown = Math.max(pageSize, Number(s.shown) || pageSize);
      st.soldOpen = !!s.soldOpen;
      try { history.scrollRestoration = 'manual'; } catch (e) {}
      var y = Number(s.y) || 0;
      setTimeout(function () { window.scrollTo(0, y); }, 0);
      requestAnimationFrame(function () { window.scrollTo(0, y); });
      return true;
    }
    window.addEventListener('pagehide', save);
    d.addEventListener('visibilitychange', function () { if (d.visibilityState === 'hidden') save(); });
    el.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.yn-cell a')) save(); });

    /* interactions */
    el.addEventListener('click', function (e) {
      var t = e.target; if (!t.closest) return;
      var chip = t.closest('[data-yn-size-chip]');
      if (chip) {
        var v = chip.getAttribute('data-yn-size-chip'), cur = sizeGet();
        popPill(chip);
        sizeSet(v && v === cur ? null : (v || null));
        return;
      }
      if (t.closest('[data-yn-more-btn]')) {
        var from = st.shown; st.shown += pageSize; render();
        var L = compute(), list = L.size ? L.inS : L.inS.concat(L.out), next = list[from];
        if (next) { var a = $('a', next.el); if (a) { try { a.focus({ preventScroll: true }); } catch (err) {} } }
        return;
      }
      if (t.closest('[data-yn-sold-toggle]')) { st.soldOpen = !st.soldOpen; render(); return; }
    });
    if (sheet) {
      sheet.addEventListener('click', function (e) {
        var t = e.target; if (!t.closest) return;
        var b = t.closest('[data-yn-f]');
        if (b) {
          var k = b.getAttribute('data-yn-f'), v = b.getAttribute('data-v');
          if (k === 'avail') st.f.avail = v === '1'; else st.f[k] = v;
          st.shown = pageSize; popPill(b); render({ animate: true });
          return;
        }
        if (t.closest('[data-yn-fclear]')) { st.f = Object.assign({}, DEF); st.shown = pageSize; render({ animate: true }); }
      });
    }
    d.addEventListener('yuno:size', function () {
      if (!el.isConnected) return;
      st.shown = pageSize; render({ animate: true }); centreChip();
    });
    window.addEventListener('resize', stickyTop);

    /* ?size=<label> is accepted */
    try {
      var qs = new URLSearchParams(location.search).get('size');
      if (qs) { var ns = normSize(qs); if (ns && ns !== sizeGet()) sizeSet(ns); }
    } catch (e) {}

    var restored = restore();
    render();
    de.classList.remove('yn-has-size');
    stickyTop();
    setTimeout(stickyTop, 400);
    setTimeout(centreChip, 60);
    if (restored) { /* scroll was set above */ }
  }

  /* ================= global wiring ================= */
  d.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var b;
    if ((b = t.closest('[data-yn-qty]'))) { var li = b.closest('.yn-line'); if (li) changeQty(li, Number(b.getAttribute('data-yn-qty')), b); return; }
    if ((b = t.closest('[data-yn-remove]'))) { var li2 = b.closest('.yn-line'); if (li2) removeLine(li2, qq[li2.getAttribute('data-yn-line')] ? qq[li2.getAttribute('data-yn-line')].want : 0); return; }
    if ((b = t.closest('[data-yn-note-toggle]'))) { toggleNote(b); return; }
    if ((b = t.closest('[data-yn-cart-add]'))) { onCartAdd(b); return; }
    var sheetQ = t.closest('#yn-sheet-quick');
    if (sheetQ) {
      if (Q.phase === 'adding') return;
      if ((b = t.closest('.yn-q__pill'))) {
        var s = b.getAttribute('data-size'); Q.size = s; setErr('');
        updateQuick('size');
        var vv = variantFor(Q.colour, s);
        if (!vv || !vv.available) shake(b, 3); else popPill(b);
        return;
      }
      if ((b = t.closest('.yn-q__sw'))) {
        Q.colour = b.getAttribute('data-colour'); setErr('');
        updateQuick('colour'); pop(b, 1.12);
        return;
      }
      if (t.closest('[data-yn-q-add]')) { onQuickAdd(); return; }
    }
  });
  d.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-yn-note]')) {
      clearTimeout(noteTimer);
      var v = t.value;
      noteTimer = setTimeout(function () { saveNote(v); }, 700);
    }
  });
  d.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-yn-note]')) { clearTimeout(noteTimer); saveNote(t.value); }
  });
  d.addEventListener('yuno:size', function () { refreshSuggLabels(d); });

  function initAll(scope) {
    $$('[data-yn-coll]', scope).forEach(initColl);
    var first = $('[data-yn-note]', scope); if (first && lastNote == null) lastNote = first.value;
    refreshSuggLabels(scope);
  }
  d.addEventListener('shopify:section:load', function (e) { initAll(e.target || d); });

  assignApi();
  d.addEventListener('yuno:ready', assignApi);
  initAll(d);
})();
